// extracted by mini-css-extract-plugin
export default {"page":"w6-z","cartModal":"x6-z","checkout":"y6-z","placeholder":"z6-z","account":"A6-z"};